// Initialize the engage variable globally
window.engage = undefined;
window.cdpReady = false;



// ============================================
// STRICT GLOBAL VARIABLE VALIDATION
// ============================================
// Validate that ALL required CDP global variables are available
(function() {
    'use strict';

    const requiredVariables = [
        'CDP_CLIENT_KEY',
        'CDP_TARGET_URL',
        'CDP_POINT_OF_SALE',
        'CDP_COOKIE_DOMAIN',
        'CDP_BASE_PATH'
    ];

    const missingVariables = [];

    requiredVariables.forEach(function(varName) {
        if (typeof window[varName] === 'undefined' || window[varName] === null || window[varName] === '') {
            missingVariables.push(varName);
        }
    });

    if (missingVariables.length > 0) {
        console.warn('CDP: Required global variables are missing or empty:', missingVariables);
        console.warn('CDP: Please ensure all CDP global variables are set in HTML <head> before loading init.js');
        console.warn('CDP not initialized');
        return; // Exit completely - do not initialize CDP
    }

    if (typeof window.CDP_INTERNAL_USER !== 'undefined' && window.CDP_INTERNAL_USER === true) {
        window.CDP_POINT_OF_SALE = window.CDP_POINT_OF_SALE + '-internal';
    }

    // ============================================
    // COOKIE CONSENT CHECK
    // ============================================
    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    function hasConsentGranted() {
        const cookieValue = getCookie('OptanonConsent');

        // If cookie doesn't exist, treat as consent granted (for dev/uat environments)
        if (!cookieValue) {
            
            return true;
        }

        // Cookie exists, check the C0004 value (Targeting Cookies)
        const groupsMatch = cookieValue.match(/groups=([^&]+)/);
        if (!groupsMatch) {
            
            return true;
        }

        const groups = decodeURIComponent(groupsMatch[1]);
        const groupValueMatch = groups.match(/C0004:(\d)/);

        if (!groupValueMatch) {
            
            return true;
        }

        const c0004Value = groupValueMatch[1];
        

        return c0004Value === '1';
    }

    // Check cookie consent before proceeding
    if (!hasConsentGranted()) {
        return;
    }

    // ============================================
    // BERKELEY CDP HELPER
    // ============================================
    window.berkeleycdp = {
        pageType: null,
        developmentName: null,
        developmentId: null,
        phaseName: null,
        propertyName: null,
        siteCode: null,
        plotCode: null,

        channel: null,
        currency: null,
        pointOfSale: null,
        language: null,

        // Set static event fields once when CDP is ready
        initializeBaseEventData: function() {
            this.channel = this.isMobileDevice() ? 'MOBILE_WEB' : 'WEB';
            this.currency = this.getCurrency();
            this.pointOfSale = window.CDP_POINT_OF_SALE;
            this.language = this.getLanguage();
            
        },

        initializePageType: function() {
            this.pageType = this._computePageType();
            
        },

        initializePageData: function() {
            const pageType = this.pageType;

            if (pageType === 'development' || pageType === 'phase' || pageType === 'property' || pageType === 'form') {
                this.developmentName = this._computeDevelopmentName(pageType);
                this.developmentId = this._computeDevelopmentId();
            } else {
                this.developmentName = null;
                this.developmentId = null;
            }

            if (pageType === 'property') {
                this.siteCode = this._computeSiteCode();
                this.plotCode = this._computePlotCode();
                this.propertyName = this._computePropertyName();
            } else {
                this.siteCode = null;
                this.plotCode = null;
                this.propertyName = null;
            }

            if (pageType === 'phase' || pageType === 'property') {
                this.phaseName = this._computePhaseName(pageType);
            } else {
                this.phaseName = null;
            }

            
        },

        // Detect if the device is mobile
        isMobileDevice: function() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // Check for mobile user agents
            const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i;
            const isMobileUA = mobileRegex.test(userAgent.toLowerCase());
            // Check screen width as additional indicator (mobile typically < 768px)
            const isMobileScreen = window.innerWidth < 768;
            // Check for touch capability
            const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            // Return true if user agent indicates mobile OR (small screen AND touch capable)
            return isMobileUA || (isMobileScreen && hasTouch);
        },

        // Detect browser language (e.g., "en-GB", "en-US", "fr-FR")
        getLanguage: function() {
            const lang = navigator.language || navigator.userLanguage || 'en-GB';
            // Extract the language code (e.g., "en" from "en-GB")
            return lang.split('-')[0].toUpperCase();
        },

        // Detect currency based on browser language/region
        getCurrency: function() {
            const lang = navigator.language || navigator.userLanguage || 'en-GB';
            // Map common locales to currencies
            const currencyMap = {
                'en-GB': 'GBP',
                'en-US': 'USD',
                'en-AU': 'AUD',
                'en-CA': 'CAD',
                'fr-FR': 'EUR',
                'de-DE': 'EUR',
                'es-ES': 'EUR',
                'it-IT': 'EUR',
                'nl-NL': 'EUR',
                'pt-PT': 'EUR',
                'ja-JP': 'JPY',
                'zh-CN': 'CNY',
                'ko-KR': 'KRW'
            };
            // Default to GBP for UK-based site
            return currencyMap[lang] || 'GBP';
        },

        // Get common event data structure
        getEventData: function(additionalData) {
            const baseData = {
                channel: this.channel,
                currency: this.currency,
                pointOfSale: this.pointOfSale,
                language: this.language,
                page: window.location.pathname
            };

            // Merge with additional data if provided
            if (additionalData) {
                for (const key in additionalData) {
                    if (Object.hasOwn(additionalData, key)) {
                        baseData[key] = additionalData[key];
                    }
                }
            }

            return baseData;
        },

        // Get page type - PUBLIC API
        getPageType: function() {
            return this.pageType;
        },

        // Get development name cached during page data initialization
        getDevelopmentName: function() {
            return this.developmentName;
        },

        // Get development ID cached during page data initialization
        getDevelopmentId: function() {
            return this.developmentId;
        },

        // Get phase name cached during page data initialization (phase pages only)
        getPhaseName: function() {
            return this.phaseName;
        },

        // Get property name cached during page data initialization (property pages only)
        getPropertyName: function() {
            return this.propertyName;
        },

        // Get site code cached during page data initialization (property pages only)
        getSiteCode: function() {
            return this.siteCode;
        },

        // Get plot code cached during page data initialization (property pages only)
        getPlotCode: function() {
            return this.plotCode;
        },

        /**
         * Send a CDP event via Sitecore Engage with standard logging/error handling
         */
        sendEvent: function(eventName, extensionData) {
            if (!window.engage) {
                console.warn('CDP: Engage SDK not initialized yet');
                return false;
            }

            const eventData = this.getEventData();

            

            try {
                window.engage.event(eventName, eventData, extensionData);
                
                return true;
            } catch (error) {
                console.error('[CDP] Error sending ' + eventName + ' event:', error);
                return false;
            }
        },

        /**
         * Extract plain text from a data-sub-html string
         */
        getTextFromSubHtml: function(html) {
            if (!html) {
                return '';
            }

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            return (tempDiv.textContent || '').trim();
        },

        /**
         * Run a callback when the DOM is ready and CDP is ready
         */
        whenReady: function(callback) {
            const runWhenCdpReady = function() {
                if (window.cdpReady) {
                    callback();
                } else {
                    window.addEventListener('cdpReady', callback);
                }
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', runWhenCdpReady);
            } else {
                runWhenCdpReady();
            }
        },

        // LightGallery helpers live in lightgallerytracking.js (loaded on demand)

        _computeDevelopmentId: function() {
            const dynamicDevField = document.querySelector('[data-sc-field-name="DynamicDevelopmentId"]');
            return dynamicDevField ? dynamicDevField.value : '';
        },

        _computeDevelopmentName: function(pageType) {
            const isPhasePage = pageType === 'phase';
            const isPropertyPage = pageType === 'property';

            // On phase and property pages the H1 may not contain only the development name
            if (isPhasePage || isPropertyPage) {
                const devMenuLink = document.querySelector('.submenu-component .submenu-list > li:first-child a');
                if (devMenuLink && devMenuLink.textContent) {
                    return devMenuLink.textContent.trim();
                }
            }

            const mainHeading = document.querySelector('h1');
            if (mainHeading && mainHeading.textContent) {
                return mainHeading.textContent.trim();
            }

            return document.title;
        },

        _computePhaseName: function(pageType) {
            if (pageType === 'phase') {
                const mainHeading = document.querySelector('.development-description-wrapper h1') ||
                    document.querySelector('h1');
                if (mainHeading && mainHeading.textContent) {
                    return mainHeading.textContent.trim();
                }

                return '';
            }

            if (pageType === 'property') {
                const propertyDescription = document.querySelector('[sc-test="property-description-component"]');
                if (!propertyDescription) {
                    return null;
                }

                // Phase is included in the H1 when the component also has a p.font--heading-1
                // (previously this was signalled by two H1 elements).
                const heading = propertyDescription.querySelector('h1');
                const secondaryHeading = propertyDescription.querySelector('p.font--heading-1');
                if (!heading || !secondaryHeading || !heading.textContent) {
                    return null;
                }

                const headingText = heading.textContent.trim();
                const commaIndex = headingText.indexOf(',');

                if (commaIndex === -1) {
                    return null;
                }

                return headingText.slice(commaIndex + 1).trim();
            }

            return null;
        },

        _computePropertyName: function() {
            const mainHeading = document.querySelector('h1');
            if (mainHeading && mainHeading.textContent) {
                const headingText = mainHeading.textContent.trim();
                const commaIndex = headingText.indexOf(',');

                if (commaIndex !== -1) {
                    return headingText.slice(0, commaIndex).trim();
                }

                return headingText;
            }

            return '';
        },

        _computeSiteCode: function() {
            const pathname = window.location.pathname;
            const parts = pathname.split('/');

            if (parts.length >= 3 && parts[1] === 'development') {
                const devSegment = parts[2];
                const match = devSegment.match(/-([a-z]\d+)$/i);
                if (match && match[1]) {
                    return match[1];
                }
            }

            return 'siteCode';
        },

        _computePlotCode: function() {
            const pathname = window.location.pathname;
            const parts = pathname.split('/');

            for (let i = 0; i < parts.length; i++) {
                if (parts[i].startsWith('property-')) {
                    const match = parts[i].match(/^property-([a-z]\d+)/i);
                    if (match && match[1]) {
                        return match[1];
                    }
                }
            }

            return 'plotCode';
        },

        // Internal function to compute page type
        _computePageType: function() {
            const pathname = window.location.pathname.toLowerCase();
            const pathParts = pathname.split('/').filter(part => part.length > 0);

            // If no path parts, it's the homepage
            if (pathParts.length === 0) {
                return 'homepage';
            }

            // Get the first folder in the path
            const firstFolder = pathParts[0];

            // Check for submenu component first (works for both development and property pages regardless of URL structure)
            const submenu = document.querySelector('.submenu-component');
            if (submenu) {
                const scTest = submenu.getAttribute('sc-test');

                if (scTest === 'development-submenu') {
                    return 'development';
                } else if (scTest === 'phase-submenu') {
                    return 'phase';
                } else if (scTest === 'property-submenu') {
                    return 'property';
                }
            }

            

            // Check if it's a developments page by URL (production uses /developments/...)
            if (firstFolder === 'developments') {

                // Check if page contains a form in the main content area
                const formElement = document.querySelector('.content-main .main-container form');

                if (formElement) {
                    return 'form';
                }

                // Check if page has breadcrumbs (indicates list page)
                const breadcrumbs = document.querySelector('.content-main .breadcrumbs');

                if (breadcrumbs) {
                    return 'listChildren';
                }

                // Default for other developments pages
                return 'default';
            }

            // Check if it's a helping-you-move page
            if (firstFolder === 'helping-you-move') {
                // Check if it's a child of berkeley-inspiration (has third folder)
                const secondFolder = pathParts[1];
                const thirdFolder = pathParts[2];

                if (secondFolder === 'berkeley-inspiration' && thirdFolder) {
                    return 'berkeley-inspiration';
                }

                return 'helping-you-move';
            }

            // Check if it's a news-and-insights page
            if (firstFolder === 'news-and-insights') {
                const secondFolder = pathParts[1];
                const thirdFolder = pathParts[2];

                // Check if it's a news article (news-and-features/20YY/...)
                if (secondFolder === 'news-and-features' && thirdFolder) {
                    // Check if third folder matches year pattern 20YY where YY > 14
                    const yearMatch = thirdFolder.match(/^20(\d{2})$/);

                    if (yearMatch) {
                        const year = parseInt(yearMatch[1], 10);

                        if (year > 14) {
                            return 'news-article';
                        }
                    }
                }

                return 'news-and-insights';
            }

            // Map specific folders to page types with spaces
            const pageTypeMap = {
                'about-us': 'about us',
                'investors': 'investors',
                'my-home': 'my home',
                'search-results': 'search results',
                'sitemap': 'sitemap'
            };

            // Check if first folder has a specific mapping
            if (pageTypeMap[firstFolder]) {
                return pageTypeMap[firstFolder];
            }

            // Return 'default' for other pages
            return 'default';
        }
    };

    // ============================================
    // MODULE LOADING
    // ============================================
    function loadCDPModules() {
        const pathname = window.location.pathname.toLowerCase();
        const pageType = window.berkeleycdp.getPageType();

        // Debug: Log page type to help with troubleshooting
        
        const modulesToLoad = [];

        // Load experiments first in case they affect code used in other modules
        if (window.PERSONALIZE_EXPERIMENTS && Array.isArray(window.PERSONALIZE_EXPERIMENTS)) {
            window.PERSONALIZE_EXPERIMENTS.forEach(function(experiment) {
                const experimentName = experiment.name;

                // Check if experiment should run on current page
                if (experiment.pages) {
                    let shouldLoad = false;

                    // Support array of page paths
                    if (Array.isArray(experiment.pages)) {
                        shouldLoad = experiment.pages.some(function(page) {
                            return pathname === page.toLowerCase();
                        });
                    }
                    // Support regex pattern (as string)
                    else if (typeof experiment.pages === 'string') {
                        try {
                            const regex = new RegExp(experiment.pages);
                            shouldLoad = regex.test(pathname);
                        } catch (e) {
                            console.error('[CDP] Invalid regex pattern for experiment:', experimentName, e);
                        }
                    }

                    if (!shouldLoad) {
                        
                        return; // Skip this experiment
                    }
                }

                // Experiments are now in the experiments subfolder
                // Pass friendlyId through modulesToLoad
                modulesToLoad.push({
                    file: experimentName,
                    key: experimentName,
                    friendlyId: experiment.personalizeFriendlyId
                });

                
            });
        }

        // Global modules - load on ALL pages
        modulesToLoad.push({ file: 'searchtracking', key: 'searchTracking' });
        modulesToLoad.push({ file: 'findahomeclick', key: 'findAHomeClick' });
        modulesToLoad.push({ file: 'brochuredownloadclick', key: 'brochureDownloadClick' });
        modulesToLoad.push({ file: 'menuclicktracking', key: 'menuClickTracking' });
        modulesToLoad.push({ file: 'tabbedcomponentclick', key: 'tabbedComponentClick' });
        modulesToLoad.push({ file: 'telephonenumberclick', key: 'telephoneNumberClick' });

        // Page-specific modules
        if (pageType === 'homepage') {
            modulesToLoad.push({ file: 'developmentcardclick', key: 'developmentCardClick' });
        }

        // LightGallery shared helpers — must load before floorplan/gallery modules
        if (pageType === 'property' || pageType === 'development' || pageType === 'phase') {
            modulesToLoad.push({ file: 'lightgallerytracking', key: null });
        }

        if (pageType === 'property') {
            modulesToLoad.push({ file: 'floorplanclick', key: 'floorplanClick' });
        }

        if (pageType === 'development' || pageType === 'phase') {
            modulesToLoad.push({ file: 'galleryclick', key: 'galleryClick' });
        }

        if (pageType === 'my home') {
            modulesToLoad.push({ file: 'myhomesignin', key: 'myHomeSignIn' });
        }
        
        // Development, property, and phase page modules
        
        if (pageType === 'development' || pageType === 'property' || pageType === 'phase') {
            
            modulesToLoad.push({ file: 'developmentmenuclick', key: 'developmentMenuClick' });
        }

        if (pageType === 'development' && (window.VT_TRACKING === true || (typeof VT_TRACKING !== 'undefined' && VT_TRACKING === true))) {
            modulesToLoad.push({ file: 'virtualtourclick', key: 'virtualtourClick' });
        }

        // Always load Contact Form tracking (handles Register Interest and other forms)
        modulesToLoad.push({ file: 'contactformtracking', key: 'contactFormTracking' });

        // Load all modules
        modulesToLoad.forEach(function(module) {
            loadModule(module.file, module.key, module.friendlyId);
        });
    }

    function loadModule(moduleName, moduleKey, friendlyId) {
        const script = document.createElement('script');
        script.src = window.CDP_BASE_PATH + '/' + moduleName + '.min.js'; // Use validated global variable
        script.async = false;

        script.onload = function() {
            

            // Shared helpers (e.g. lightgallerytracking) extend berkeleycdp and have no init
            if (!moduleKey) {
                return;
            }

            if (window.cdpModules && window.cdpModules[moduleKey]) {
                if (typeof window.cdpModules[moduleKey].init === 'function') {
                    try {
                        // Pass friendlyId to init function if provided
                        if (friendlyId) {
                            window.cdpModules[moduleKey].init(friendlyId);
                            
                        } else {
                            window.cdpModules[moduleKey].init();
                            
                        }
                    } catch (initError) {
                        console.error('[CDP] Module initialization failed:', moduleKey, initError);
                    }
                } else {
                    
                }
            } else {
                console.warn('[CDP] Module not found in cdpModules:', moduleKey);
            }
        };

        script.onerror = function() {
            console.error('[CDP] Failed to load module:', moduleName);
        };

        document.head.appendChild(script);
    }

    // ============================================
    // CDP CONFIGURATION
    // ============================================
    function getConfig() {
        // Production configuration (server-side injected variables required)
        const config = {
            clientKey: window.CDP_CLIENT_KEY,
            targetURL: window.CDP_TARGET_URL,
            pointOfSale: window.CDP_POINT_OF_SALE,
            cookieDomain: window.CDP_COOKIE_DOMAIN,
            webPersonalization: window.CDP_WEB_PERSONALIZATION !== undefined ? window.CDP_WEB_PERSONALIZATION : true,
            cookieExpiryDays: 365,
            forceServerCookieMode: false,
            includeUTMParameters: true,
            basePath: window.CDP_BASE_PATH
        };

        

        return config;
    }

    // ============================================
    // CDP INITIALIZATION
    // ============================================
    function initializeEngageSDK() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://d1mj578wat5n4o.cloudfront.net/sitecore-engage-v.1.4.3.min.js';
        const firstScript = document.querySelector('script');
        firstScript.parentNode.insertBefore(script, firstScript);

        // Initialize the Engage SDK
        script.addEventListener('load', async () => {
            // Get configuration (all variables validated above)
            const settings = getConfig();

            // Store configuration globally
            window.cdpBasePath = settings.basePath;
            window.cdpPointOfSale = settings.pointOfSale;

            

            try {
                window.engage = await window.Engage.init(settings);

                // Wait for browser_id to be available (SDK needs time to generate it)
                let retries = 0;
                const maxRetries = 20; // 20 retries * 50ms = 1 second max wait
                while (retries < maxRetries) {
                    try {
                        const browserId = window.engage.getBrowserId();
                        if (browserId) {
                            
                            break;
                        }
                    } catch {
                        // getBrowserId() might throw if not ready yet
                    }
                    await new Promise(resolve => setTimeout(resolve, 50));
                    retries++;
                }

                if (retries >= maxRetries) {
                    console.warn('[CDP] browser_id not available after 1 second, proceeding anyway');
                }

                window.cdpReady = true;

                window.berkeleycdp.initializeBaseEventData();
                window.berkeleycdp.initializePageType();
                window.berkeleycdp.initializePageData();

                // Ensure settings are accessible on window.engage
                if (!window.engage.settings) {
                    window.engage.settings = settings;
                }

                // Dispatch custom event to notify that CDP is ready
                window.dispatchEvent(new CustomEvent('cdpReady'));

                // Prepare event data for page view using berkeleycdp helper
                const eventData = window.berkeleycdp.getEventData();

                const pageType = window.berkeleycdp.getPageType();
                const extensionData = {
                    pageType: pageType
                };

                // Send a VIEW event
                try {
                    window.engage.pageView(eventData, extensionData);
                } catch (pageViewError) {
                    console.error('CDP: Failed to send page view event', pageViewError);
                }

                // Load CDP tracking modules based on current page URL
                loadCDPModules();

            } catch (error) {
                console.error('CDP: Failed to initialize Engage SDK', error);
                console.error('CDP: Error details:', {
                    message: error.message,
                    stack: error.stack,
                    settings: settings
                });
            }
        });

        script.addEventListener('error', () => {
            console.error('CDP: Failed to load Engage SDK');
        });
    }

    initializeEngageSDK();

})(); // End of strict validation IIFE
